<template>
  <el-col
    :xs="24"
    :sm="24"
    :md="6"
    :lg="6"
    :xl="6"
    class="sidebar leftfloat sidebar_con"
  >
    <div class="grid-content bg-purple">
      <div class="tgxz fifth pc_mo">
        <div id="award" class="bor_top">
          <LoginControl></LoginControl>
        </div>
      </div>

      <div class="tgxz fifth">
        <div id="award" class="bor_top">
          <div class="titlebar">
            <div class="title">
              <span class="bottom_border">
                <a href="#">期刊浏览</a>
              </span>
              <span class="title_more">
                <router-link to="/dlistnum"></router-link>
              </span>
            </div>
          </div>
          <div class="list year_mo">
            <ul>
              <li v-for="(v, i) in Year" :key="i" v-if="i < 3" class="flex">
                <div class="leftfloat">
                  <span style="color: #00777b; font-weight: 600">{{
                    v.PublishYear
                  }}</span>
                  &nbsp;&nbsp;
                </div>
                <div
                  class="leftfloat flex"
                  style="flex-wrap: wrap; height: auto"
                >
                  <router-link
                    :to="{ path: '/OAList', query: { IssueId: view.IssueId } }"
                    v-for="(view, item) in v.Issue"
                    :key="item"
                    >{{ view.IssueNum }}</router-link
                  >
                </div>
              </li>
            </ul>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>

      <div class="tgxz fifth">
        <div id="award" class="qkgg_t bor_top">
          <div class="titlebar">
            <div class="title">
              <span class="bottom_border">
                <a @click="goLogin(2)">期刊信息</a>
              </span>
            </div>
          </div>
          <div class="qk_a list" v-html="qkjjBody" style="padding: 5px"></div>
        </div>
      </div>

      <div class="tgxz fifth">
        <div id="award" class="qkgg_t Rank bor_top">
          <div class="titlebar">
            <div class="title">
              <span class="bottom_border">
                <a href="#">理事单位</a>
              </span>
              <span class="title_more">
                <router-link to="/DirectorAndFeatures?id=2"></router-link>
              </span>
            </div>
          </div>
          <div class="qk_a list">
            <div
              class="linktext"
              v-for="(item, i) in imgList"
              :key="i"
              v-show="i < 5 "
            >
               <a
                 :href="item.Url"
                 target="_blank"
                >
                <img
                  :src="Url +item.PictureGUID"
                  style="width: 220px; height: 60px;display: inline-block;"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import Control from "./page/Control";
import Ranking from "./page/Ranking";
import Search from "../Home/Search";
import FrLinks from "../DocumentsNewsBlockControl/page/FrLinks";
import LoginControl from "../../components/LoginControl";
export default {
  name: "Sidebar",
  data() {
    return {
      activeName: "first",
      type: 1,
      activeNamea: "firsta",
      activeNameb: "firstb",
      slqk: "",
      data: {},
      Volume: "",
      newYears: "",
      newMonth: "",
      SetItem: {},
      ISSN: "",
      CN: "",
      Year: [],
      imgUrl: "",
      YearIssue_NoTtitle: "",
      activeIndex: 0,
      intnum: undefined,
      Situation: "",
      qkjjBody: "",
      imgList: [],
    };
  },
  components: { Control, Ranking, FrLinks, Search, LoginControl },
  computed: {
    top() {
      return -this.activeIndex * 51 + "px";
    },
  },
  async created() {
    // this.ScrollUp();
    let imgList = await this.$store.dispatch("_getBannerList", { ID: 2 });
    this.imgList = imgList.data.Data;
  },
  mounted() {
    this.GetCatalog();
    this.GetList();
  },
  methods: {
    handleClick(tab, event) {},
    handleClicka(tab, event) {},

    handleClick() {},
    GetCatalog() {
      this.$store
        .dispatch("_getgok")
        .then((res) => {
          this.Year = res.data.Data.Year;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    GetList() {
      this.$store
        .dispatch("_getHeader", [12])
        .then((res) => {
          if (res.data.IsSuccess) {
            this.qkjjBody = res.data.Data[0].Body;
          } else {
            console.log(res.data.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goLogin(num){
			 
			  if(window.localStorage.getItem("userInfo")){
				 if(num==1){
				 	var urldomain = "/author/#/";
				 	window.location.href=urldomain;
				    return  						
				  }else if(num==2){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/editor/#/editor/Index";
				 	 window.location.href=urldomain;
				  return  					       
				  }else if(num==3){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/expert/#/examine-manuscripts";
				 	 window.location.href=urldomain;
				 	 return 					 	 
				 	 }	
			  }else{
				  //num 1-作者 2-编辑办公 3-专家审稿
				  window.sessionStorage.setItem("Login",num)
				  this.$router.push({
				    path: '/Login'// 跳转至登录
				  })
			  }
		  },
  },
};
</script>

<style>
.qktext p {
  line-height: 24px;
}
.qkjjtext img {
  height: 216px;
  background: #dedede;
  display: inline-block;
}
.fllinks .el-tabs__content {
  margin-top: 1px !important;
}
.scroll-wrap {
  height: 200px;
  overflow: hidden;
}

.scroll-content {
  position: relative;
  transition: top 0.5s;
}
.bor_top {
  border-top: 3px solid #0e738d !important;
}
.scroll-content p {
  text-align: center;
}
.Situation {
  max-height: 163px;
  overflow: hidden;
}
.Situation li {
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  list-style-image: url(../../assets/images/arrow.gif);
}
.Situation li span {
  font-size: 15px !important;
  line-height: 28px !important;
}

#award {
  margin-top: 15px;
  padding: 15px 12px;
  box-shadow: #dee3e8 0px 2px 3px;
  -webkit-box-shadow: #dee3e8 0px 2px 3px;
  -moz-box-shadow: #dee3e8 0px 2px 3px;
  border: 1px solid #eaeaea;
  min-height: 400px;
}
.awewm {
  display: flex;
  display: -webkit-flex;
  border: 1px solid #dfdfdf;
  padding: 10px;
}
#award .titlebar {
  height: 32px;
  margin: 0px;
  overflow: hidden;
}

.titlebar .title {
  font-family: Microsoft YaHei;
  float: left;
  min-width: 220px;
  color: #0f84aa;
  width: 98%;
  font-weight: 600;
  font-size: 17px;
}
#award .titlebar .title img {
  margin-right: 7px;
  vertical-align: middle;
}
@media (min-width: 1024px) {
  #award .titlebar .title {
    min-width: 262px;
  }
}
@media (max-width: 1024px) {
  #award .titlebar .title {
    min-width: 212px;
  }
}
#award .titlebar .title a {
  color: #999;
  font-weight: 500;
  font-size: 14px;
}
a {
  color: #333;
  text-decoration: none;
}
.year_mo ul li {
  overflow: visible;
}
.list li a {
  margin-right: 10px;
}
.list li a:hover {
  color: #b91f00;
  text-decoration: revert;
}
.ewms {
  margin-right: 15px;
}
.wxsys {
  text-align: center;
  padding-top: 35px;
  background-size: cover;
  width: 38%;
}
@media only screen and (min-width: 1024px) {
  .flex {
    display: flex;
  }
}
.year_mo ul li {
  height: auto;
}
</style>
